import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { api } from '.';
export var apiGetDeelRedirectUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res, _err$response, _err$response$data, _err$response$data$de, _err$response$data$de2, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get('/deel/redirect_url');

          case 3:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            message = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de = _err$response$data.detail) === null || _err$response$data$de === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data$de[0]) === null || _err$response$data$de2 === void 0 ? void 0 : _err$response$data$de2.msg;
            console.error("Failed to fetch Deel redirect url: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function apiGetDeelRedirectUrl() {
    return _ref.apply(this, arguments);
  };
}();
export var apiDeelAuthorization = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var res, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.post('/deel/authorization', {}, {
              params: params
            });

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            message = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg;
            console.error("Failed to authorize Deel integration: ".concat(message));
            return _context2.abrupt("return", [null, _context2.t0]);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function apiDeelAuthorization(_x) {
    return _ref2.apply(this, arguments);
  };
}();